enum StakingStatus {
  Off,
  On,
}

export default StakingStatus;
